<div class="select-tree">
    <div fxLayout="row" fxLayoutAlign="center center">
        <input
            [(ngModel)]="searchByText"
            pInputText
            placeholder="Wpisz szukaną frazę"
            type="text"
            (click)="$event.stopPropagation()"
            class="searchColumnText p-column-filter"
            (keyup.enter)="search(searchByText)"
        />
        <mat-icon class="clear-icon"
                  (click)="$event.stopPropagation(); clearSearch()"
        >
            clear
        </mat-icon>
        <mat-icon class="search-icon"
                  (click)="$event.stopPropagation(); search(searchByText)"
        >
            search
        </mat-icon>
    </div>

    <p-tree
        *ngIf="searchedData"
        [value]="searchedData"
        selectionMode="checkbox"
        [(selection)]="selected"
        (onNodeSelect)="nodeSelect($event)"
        (onNodeUnselect)="nodeUnselect($event)"
        (onNodeExpand)="onClickActionInTree($event)"
        (onNodeCollapse)="onClickActionInTree($event)"
        scrollHeight="400px"
    ></p-tree>
</div>
